import { render, staticRenderFns } from "./UsersIcon.vue?vue&type=template&id=87cd224a&"
import script from "./UsersIcon.vue?vue&type=script&lang=js&"
export * from "./UsersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports